// GAVION call-brief-pipeline: « Envoyer dans le pipeline » (envoyer un lead au pipeline).
export const sendPipelineFr = {
  button: "Envoyer dans le pipeline",
  view_deal: "Voir le deal",
  title: "Envoyer au pipeline",
  stage: "Étape",
  date: "Date (optionnelle)",
  date_hint: "La date de la démo ou de la rencontre, si elle est prévue.",
  cancel: "Annuler",
  submit: "Envoyer au pipeline",
  done: "Compagnie envoyée au pipeline",
  open_deal: "Ouvrir le deal",
  errors: {
    invalid_stage: "Cette étape n'est pas une étape ouverte du pipeline.",
    forbidden: "Cette compagnie est assignée à un autre représentant.",
    not_found: "Compagnie introuvable.",
    do_not_call:
      "Cette compagnie est marquée « Ne pas appeler » : elle ne peut pas aller au pipeline.",
    unknown: "La compagnie n'a pas pu être envoyée au pipeline. Réessayez.",
  },
};
